import { Component } from '@angular/core';
import { MenuStoreService } from '@argalis-apps/angular-services';
import { Router } from '@angular/router';

@Component({
  selector: 'app-argalis-apps-demandes-encadrement-list',
  templateUrl: './demandes-encadrement-list.component.html',
  styleUrls: ['./demandes-encadrement-list.component.scss']
})
export class DemandesEncadrementListComponent {
  constructor(private menuStoreService: MenuStoreService, private router: Router) {}

  getDemandes(demandeList: any[]) {
    this.menuStoreService.emitNotificationNumber(Number(demandeList.length || 0));
  }

  changeRoute(idDetails: number) {
    this.router.navigate([`/demandes/details/${idDetails}`]);
  }
}
